import IpcRouter from '@shared/ipc/IpcRouter.ts'
import type { ViewWindowRequest } from '@shared/sidepanel/view-window-route'

export interface WindowIpcRouterType {
  openSettingsWindow: (route?: string) => Promise<void>
  openViewWindow: (request: ViewWindowRequest) => Promise<void>
  openOnboardingWindow: () => Promise<void>
  /** The gateway refused a turn because the account has no recorded 2.0 onboarding. */
  onboardingRequiredByServer: () => Promise<void>
  openPermissionsSetup: () => Promise<boolean>
  /**
   * For an account that just signed in on the onboarding window: true when the
   * server says it already finished 2.0 onboarding, which main has adopted. The
   * window then runs only the permission screens.
   */
  adoptExistingOnboarding: () => Promise<boolean>
}

class WindowIpcRouter extends IpcRouter<WindowIpcRouterType> {
  constructor() {
    super('window', {
      openSettingsWindow: true,
      openViewWindow: true,
      openOnboardingWindow: true,
      onboardingRequiredByServer: true,
      openPermissionsSetup: true,
      adoptExistingOnboarding: true,
    })
  }
}

export default WindowIpcRouter
